
import React, { FC } from 'react';
import { TopUpOnBoardForm, WalletTransactionForm } from '../components';

export const AddCreditPage: FC = () => <WalletTransactionForm />

export const TopupOnboardPage: FC = () => <TopUpOnBoardForm />